import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import cache from '../model/cache'
Vue.use(Vuex)

// 应用初始状态
const state = {
  count: 10,
  enumMap: {},
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    updateEnumMap(state, { key, value }) {
      Vue.set(state.enumMap, key, value);
    },
}

// 创建 store 实例
export default new Vuex.Store({
    modules: {
        cache // ✅ 模块名就是 'cache'
    },
    actions,
    getters,
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js